import type { ThemeConfig } from 'antd';

/* Sustainability-Pros brand mapped onto AntD tokens.
   Green #4CAF50 primary, slate #263238 sider, 6px radius (AntD default look). */
export const SIDER_BG = '#263238';

export const brandTheme: ThemeConfig = {
  token: {
    colorPrimary: '#4CAF50',
    colorLink: '#388E3C',
    colorInfo: '#4CAF50',
    borderRadius: 6,
  },
  components: {
    Layout: {
      siderBg: SIDER_BG,
      headerBg: '#ffffff',
      headerHeight: 64,
      headerPadding: '0 24px',
    },
    Menu: {
      darkItemBg: SIDER_BG,
      darkSubMenuItemBg: SIDER_BG,
      darkItemSelectedBg: '#4CAF50',
      darkItemColor: 'rgba(255,255,255,.75)',
      darkGroupTitleColor: 'rgba(255,255,255,.4)',
    },
  },
};

/* Same brand, resized for fingers. AntD's 32px default control height is a mouse
   dimension; Apple HIG asks for 44pt, and these screens get used on an iPad in a
   mechanical room, often with gloves. controlHeightSM is set explicitly because AntD
   would otherwise derive it as 0.75 * 44 = 33px, right back under the limit.
   Applied by App.tsx when useIsTouch() reports a coarse pointer. */
export const touchTheme: ThemeConfig = {
  ...brandTheme,
  token: {
    ...brandTheme.token,
    controlHeight: 44,
    controlHeightSM: 36,
  },
};
